import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { TimelineItemType, TopicType } from "@teammood/timeline";

@Component({
    selector: 'notification-preview',
    templateUrl: 'notification-preview.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
    ]
})
export class NotificationPreviewComponent {
    
    @Input() itemType: TopicType | TimelineItemType;
    @Input() notify: boolean;
  
    constructor() {}
}
